export const sharedColors = {
  brandMain: "#00A978",
  brandDark: "#008761",
  mediumGrayLight: "#F5F6F8",
  labelGray: "#6F747D",
  borderGray: "#D1D5DB",
  black: "#051711",
  red: "#C92418",
  // Accessible gray for text on white background (WCAG AA compliant)
  accessibleGray: "#4A4D52",
  // Old
  white: "#FFFFFF",
  beige: "#F3F3EE",
  gray: "#75787B",
  lightGray: "#E6E5EA",
  bluishGray: "#C4CEE3",
  blue: "#395AA1",
  darkBlue: "#141B4D",
  lightBlue: "#87B0D6",
  turquoise: "#00A7B5",
  lightTurquoise: "#B3E5E9",
  lightRed: "#EBB7C1",
  darkOrange: "#DA291C",
  orange: "#ED7D25",
  lightOrange: "#F6BD90",
  pink: "#B52555",
  lightPink: "#E9BECC",
  dropShadow: {
    main: "8px 8px 30px #02275729",
    mainSmall: "-8px 8px 30px #0F244F1F",
    light: "0px 0px 9px rgba(0, 0, 0, 0.06)",
    header: "0px 4px 16px #5A5A5A0D",
  },
}
